/**
 * Determine if there are actually items in a users cart/wishlist, and then display the notification
 * icon appropriately.
 *
 * This is required because the default Magento implementation seems to be inconsistent with hiding the bubble when there
 * are no items in the cart/wishlist.
 * Now by default, the bubble is always hidden (which also stops it from flashing up on page load), and then the javascript
 * in this file will show the bubble, if required
 */
define([
    'jquery'
], function ($) {
    'use strict';

    var miniCart = $('[data-block=\'minicart\']');
    miniCart.one('contentUpdated', function() {
        var $minicartSummary = $($(".minicart__summary")[0]);
        var itemsCount = $minicartSummary.find(".counter-number").text();
        var intItemsCount = parseInt(itemsCount);
        var $miniCartCount = $(".minicart__count");
        if (intItemsCount > 0) {
            $miniCartCount.removeClass('u-visually-hidden');
        }

        var $wishlistSummary = $(".wishlist");
        var $firstWishlistInstance = $($wishlistSummary[0]);
        var $wishlistCounter = $firstWishlistInstance.find('.counter');
        var wishlistItemsCount = $wishlistCounter.text();
        var intWishlistItemsCount = parseInt(wishlistItemsCount);
        if (intWishlistItemsCount > 0) {
            $wishlistSummary.find('.counter').removeClass('u-visually-hidden');
        }
    });
});
